import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar/Sidebar';
import MobileHeader from '../MobileHeader/MobileHeader';
import MobileFooter from '../MobileFooter/MobileFooter';
import IDCardGenerator from '../IDCardGenerator';
import Underwriting from '../Underwriting/Underwriting';
import UnderwritingDetail from '../Underwriting/UnderwritingDetail';
import Members from '../Members/Members';
import MemberDetailNew from '../Members/MemberDetailNew';
import Groups from '../Groups/Groups';
import GroupDetail from '../Groups/GroupDetail';
import GroupCreate from '../Groups/GroupCreate';
import RegularGroups from '../Groups/RegularGroups';
import Admins from '../Admins/Admins';
import AdminDetail from '../Admins/AdminDetail';
import AdminCreate from '../Admins/AdminCreate';
import { useInsuranceStore } from 'src/store/insurance';

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { plans, getPlans } = useInsuranceStore();

  const pathParts = location.pathname.split('/').filter(Boolean);
  const activeTab = pathParts[0] || 'underwriting';
  const isMemberDetail = pathParts[0] === 'members' && pathParts.length > 1;
  const isGroupDetail = pathParts[0] === 'admin-groups' && pathParts.length > 1 && pathParts[1] !== 'create';
  const isGroupCreate = pathParts[0] === 'admin-groups' && pathParts[1] === 'create';
  const isAdminDetail = pathParts[0] === 'admins' && pathParts.length > 1 && pathParts[1] !== 'create';
  const isAdminCreate = pathParts[0] === 'admins' && pathParts[1] === 'create';
  const isUnderwritingDetail = pathParts[0] === 'underwriting' && pathParts.length > 1;

  const setActiveTab = (tab: string) => {
    navigate(`/${tab}`);
  };

  const renderContent = () => {
    // Check for detail pages first
    if (isMemberDetail) {
      return <MemberDetailNew />;
    }
    
    if (isGroupDetail) {
      return <GroupDetail key={location.pathname} />;
    }
    
    if (isGroupCreate) {
      return <GroupCreate />;
    }
    
    if (isAdminDetail) {
      return <AdminDetail key={location.pathname} />;
    }
    
    if (isAdminCreate) {
      return <AdminCreate />;
    }
    
    if (isUnderwritingDetail) {
      return <UnderwritingDetail key={location.pathname} />;
    }

    // Then check for main pages
    switch (activeTab) {
      case 'underwriting':
        return <Underwriting />;
      case 'id-cards':
        return <IDCardGenerator />;
      case 'members':
        return <Members />;
      case 'groups':
        return <RegularGroups />;
      case 'admin-groups':
        return <Groups />;
      case 'admins':
        return <Admins />;
      default:
        return <Underwriting />;
    }
  };

  useEffect(() => {
    if (plans.length === 0) {
      getPlans();
    }
  }, [plans.length, getPlans]);

  return (
    <div className="bg-primary h-screen">
      <MobileHeader />

      <div className="hidden lg:flex h-full">
        <Sidebar
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          isOpen={true}
        />
        <div className="flex-1 p-4 ml-0">{renderContent()}</div>
      </div>

      <div className="lg:hidden flex flex-col h-full">
        <div className="flex-1 pt-16 pb-20 px-4 overflow-y-auto">
          {renderContent()}
        </div>
        <MobileFooter activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
    </div>
  );
};

export default Dashboard;
